// extracted by mini-css-extract-plugin
export default {"admin-users-view":"adminUsers_admin-users-view__lpGGN","admin-users-container":"adminUsers_admin-users-container__WKYiY","users-inventory":"adminUsers_users-inventory__MSMcS"};